// docs: https://github.com/altostra/type-validations#readme
import { objectOf, anyOf } from "@altostra/type-validations";
import { number, nullValidation } from "@altostra/type-validations/lib/primitives";

export const isEngagementAppGroupIdPushSettingsResult = objectOf({
  android_default_time_to_live: anyOf(number, nullValidation),
  huawei_default_time_to_live: anyOf(number, nullValidation),
  web_default_time_to_live: anyOf(number, nullValidation),
  kindle_default_time_to_live: anyOf(number, nullValidation),
});
